export default __webpack_public_path__ + "static/media/09.6d938026.jpg";